import { dxfSidePanelsBelowToolbarQuery } from 'modules/common/viewer/dxfViewer/constants';
import { useDxfMappingSubject } from 'modules/common/viewer/dxfViewer/mapping/hooks/useDxfMappingSubject';
import { useDxfMappingActions } from 'modules/common/viewer/dxfViewer/mapping/mappingActions';
import type { DxfViewerSession } from 'modules/common/viewer/dxfViewer/session/types';
import { useReadableStore } from 'modules/common/viewer/dxfViewer/session/useSessionState';

/**
 * How the side panels clear the toolbar floating over the canvas: below
 * `containerQuery`'s width (`dxfSidePanelsBelowToolbarQuery`) the toolbar
 * reaches the panels, so they move down to `top`.
 *
 * The split banner mapping mode may show under its toolbar is stretched to the
 * toolbar's width, so it collides at the same width and only moves `top` further
 * down.
 */
export const useDxfSidePanelsClearance = (session: DxfViewerSession) => {
  const mode = useReadableStore(session.mode);
  const mapping = useDxfMappingSubject(session);
  const { splitToLineItems } = useDxfMappingActions();
  const isSplitBannerVisible =
    mapping !== null && splitToLineItems.getIsVisible(mapping);

  return {
    containerQuery: dxfSidePanelsBelowToolbarQuery(mode),
    top: isSplitBannerVisible ? '6.75rem' : '3rem',
  };
};
